import { CategoryTypeEnum } from '@repo/common/enums';
import {
  BookingException,
  BookingInternalNote,
  BookingShopContextEnum,
  BookingResourceTypeEnum,
} from './booking.interface';
import { Meeting } from './meeting.interface.ts';

export interface Event {
  end?: Date;
  id: string;
  resource: {
    amount?: number;
    category?: CategoryTypeEnum;
    comments?: string;
    country?: string;
    currency?: string;
    customerId?: string;
    duration?: number;
    email?: string;
    exception?: BookingException;
    extraTimeAfterSec?: number;
    image?: string | null;
    isInThePast?: boolean;
    name?: string;
    firstName?: string;
    orderId?: string;
    phoneNumber?: string;
    price?: string;
    recurrence?: string;
    resources?: EventResources[];
    context?: BookingShopContextEnum;
    size?: string;
    sku?: string;
    title?: string;
    sharedPhoneNumber?: string;
    sharedOrderNumber?: string;
    sharedLeasingNumber?: string;
    meeting?: Meeting;
    isCancelable?: boolean;
    isNoShow?: boolean;
    internalNote?: BookingInternalNote;
  };
  start?: Date;
  title?: string;
  resourceId?: string;
  key?: string;
}

export interface EventResources {
  reservationId?: string;
  resourceSku?: string;
  exceptionId?: string;
  type?: BookingResourceTypeEnum;
  name?: string;
}

export interface UnavailabilityEvent extends Event {
  resource: {
    category: CategoryTypeEnum.UNAVAILABILITY;
    duration?: number;
    exception: BookingException;
    isInThePast?: boolean;
    resources?: EventResources[];
  };
}

export const isUnavailabilityEvent = (
  event?: Event,
): event is UnavailabilityEvent => {
  return (
    event?.resource?.category === CategoryTypeEnum.UNAVAILABILITY &&
    event?.resource?.exception !== undefined
  );
};
